import { createContext } from 'react';

const defaultValue = {
  theme: 0,
  setTheme: () => {},
};

export const SettingsContext = createContext(defaultValue);
export const SettingsProvider = SettingsContext.Provider;
export const SettingsConsumer = SettingsContext.Consumer;
